<template>
    <div id="chat">
        <!-- CHAT -->
        <PortalSidebar>
            <ChatSocketComponent v-if="isChatV2"
                :canBan="true"
                :room="buildRoomName({appointment_id: appointmentId, event_id: eventId})"
                :timezone="timezone"
            />
            <ChatComponent v-else
                :url="url"
                :canBan="true"
            />
        </PortalSidebar>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex';
    import ChatComponent from './chat/ChatComponent';
    import ChatSocketComponent from "./chat/ChatSocketComponent";
    import EventService from "../services/EventService";
    import PortalSidebar from "./PortalSidebar";

    import { buildRoomName } from "@/utils/Message";

    export default {
        name: "SessionChat",
        components: {
            ChatComponent,
            ChatSocketComponent,
            PortalSidebar,
        },
        props: {
            appointmentId: Number,
            timezone: {
                type: String,
                required: true,
            },
        },
        computed: {
            url() {
                return EventService.urlForAppointmentChatSocket(this.appointmentId);
                // return EventService.urlForChatSocket();
            },
            isChatV2() {
                return window.JS_CHAT_V2;
            },
            ...mapGetters({
                eventId: "currentEventId",
            })
        },
        methods: {
            buildRoomName,
        }
    }
</script>

<style>

</style>